module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-977f22aa.png";